import { Flex, Button, Text, Em } from "@radix-ui/themes";
import React from "react";

interface StartNewChatProps {
  chatEnded: boolean;
  onClick: () => Promise<void>;
}

export function StartNewChat({ chatEnded, onClick }: StartNewChatProps) {
  return (
    <Flex {...(chatEnded ? { px: "3", py: "4" } : {})}>
      <Flex
        width={"100%"}
        {...(chatEnded ? { px: "3", py: "2" } : {})}
        direction={"column"}
        gap={"2"}
        style={{ backgroundColor: "var(--gray-2)", borderRadius: "8px" }}
        aria-live="polite"
      >
        {chatEnded && (
          <Text size={"2"}>
            <Em>The conversation has ended</Em>
          </Text>
        )}

        {chatEnded && (
          <div>
            <Button
              size={"1"}
              color={"gray"}
              variant={"solid"}
              onClick={onClick}
              className="qc-Chat__CTAButton"
              aria-label="Start new chat"
            >
              Start New Chat
            </Button>
          </div>
        )}
      </Flex>
    </Flex>
  );
}
